import React from 'react';
import VideoPlaylistLabels from './properties/videoPlaylistLabels';
import VideoProps from './properties/videoProps';

interface VideoPlayerItemProp {
  order: number;
  videoConfig: VideoProps;
  isCurrent: boolean;
  videoController: React.ReactNode;
  labels: VideoPlaylistLabels;
  title: string;
  position: number;
  onPlay: (position: number) => void;
  isReachable: boolean
}
const VideoPlayerItem = (props: VideoPlayerItemProp): any => {
  const { isCurrent, videoController, order, labels, title, position, videoConfig, isReachable } = props;
  const { headline, thumbnail, altText } = videoConfig;
  const ariacurent = true;

  const onPlay = (event: { preventDefault: () => void }) => {
    event.preventDefault();
    if (!props.onPlay) return;

    // triger playback
    props.onPlay(position);
  };

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a
      onClick={onPlay}
      href="#"
      aria-label={`${title} ${labels.play}`}
      className={isCurrent ? `video-playlist__item active` : `video-playlist__item`}
      aria-current={isCurrent ? ariacurent : !ariacurent}
      role="button"
      tabIndex={isReachable?0:-1}
    >
      <div className="video-playlist__item__order">
        <span className="ic-play" />
        <span className="order-number">{order + 1}</span>
      </div>
      <div className="video-playlist__item__image">
        <img src={thumbnail} alt={altText} />
        <span className="ic-play" />
      </div>
      <div className="video-playlist__item__content">
        <h4 className="hl-h4">{headline}</h4>
        {videoController}
      </div>
    </a>
  );
};

export default VideoPlayerItem;
